module.exports = __webpack_public_path__ + "img/coolant-temp-hot.102dac7e.svg";